<div
  [class.bg-violet-100]="aside$ | async"
  [class.dark:bg-[#252c5f]]="aside$ | async"
  class="flex flex-col flex-1 min-h-0"
>
  <div class="w-full flex flex-col flex-1 min-h-0">
    <div
      class="shrink-0 mx-auto lg:mx-0 lg:max-w-none flex items-center justify-between border-b border-violet-200/50 dark:border-[#3c4377] p-6"
    >
      <h2 class="text-lg text-secondary dark:text-white font-semibold">CRM</h2>
      <button type="button" (click)="closeAside()" class="hover:opacity-90">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          class="size-5 text-secondary"
        >
          <path
            d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"
          />
        </svg>
      </button>
    </div>

    <!-- Save to CRM Section -->
    <div class="shrink-0 px-6 pt-6">
      <!-- Save to CRM Button — only if NOT already saved -->
      <button
        *ngIf="canSaveToCrm"
        type="button"
        (click)="saveToCrm()"
        [disabled]="(saveReportLoading$ | async)"
        class="w-full flex justify-center items-center gap-2 text-white bg-primary hover:opacity-90 hover:bg-primary_v2 disabled:opacity-50 disabled:cursor-not-allowed rounded-md text-sm px-5 py-2 font-medium transition-colors duration-200 dark:bg-purple-800 dark:hover:bg-primary"
      >
        <svg *ngIf="!(saveReportLoading$ | async)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.233-2.33 3 3 0 0 1 3.758 3.848A3.752 3.752 0 0 1 18 19.5H6.75Z"/>
        </svg>
        <svg *ngIf="saveReportLoading$ | async" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>{{ (saveReportLoading$ | async) ? "Saving..." : "Save to CRM" }}</span>
      </button>

      <!-- Update existing to CRM — shown if already saved -->
      <button
        *ngIf="canUpdateCrm"
        type="button"
        (click)="saveToCrm()"
        [disabled]="(saveReportLoading$ | async)"
        class="w-full flex justify-center items-center gap-2 text-white bg-green-600 hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed rounded-md text-sm px-5 py-2 font-medium transition-colors duration-200"
      >
        <svg *ngIf="!(saveReportLoading$ | async)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
        </svg>
        <svg *ngIf="saveReportLoading$ | async" class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <span>{{ (saveReportLoading$ | async) ? "Updating..." : "Update existing to CRM" }}</span>
      </button>
    </div>

    <div
      class="p-6 overflow-y-auto flex-1 min-h-0 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-violet-200 hover:scrollbar-thumb-transparent"
    >
      <!-- CRM Provider section title -->
      <div *ngIf="isConnectedToHubSpot && isConnectedToLivespace" class="flex items-center gap-2 mb-3">
        <button type="button" (click)="switchCrmProvider('hubspot')"
          [ngClass]="activeCrmProvider === 'hubspot' ? 'bg-violet-500 text-white' : 'bg-violet-500/10 text-violet-500 hover:bg-violet-500/20'"
          class="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md transition-colors">
          <svg class="w-4 h-4" [class.fill-white]="activeCrmProvider === 'hubspot'" [class.fill-secondary]="activeCrmProvider !== 'hubspot'" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"/></svg>
          HubSpot
        </button>
        <button type="button" (click)="switchCrmProvider('livespace')"
          [ngClass]="activeCrmProvider === 'livespace' ? 'bg-blue-600 text-white' : 'bg-blue-600/10 text-blue-600 hover:bg-blue-600/20'"
          class="flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md transition-colors">
          <img src="assets/images/livespace.png" alt="Livespace" class="w-4 h-4 rounded"/>
          Livespace
        </button>
      </div>

      <div
        *ngIf="activeCrmProvider === 'hubspot' && !(isConnectedToHubSpot && isConnectedToLivespace)"
        class="flex items-center gap-1.5 mb-1.5"
      >
        <svg
          class="w-5 h-5 fill-secondary"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
        >
          <title>HubSpot icon</title>
          <path
            d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"
          />
        </svg>
        <span class="text-base font-semibold text-secondary">HubSpot</span>
      </div>

      <div
        *ngIf="activeCrmProvider === 'livespace' && !(isConnectedToHubSpot && isConnectedToLivespace)"
        class="flex items-center gap-1.5 mb-1.5"
      >
        <img src="assets/images/livespace.png" alt="Livespace" class="w-5 h-5 rounded"/>
        <span class="text-base font-semibold text-secondary">Livespace</span>
      </div>

      <div
        class="flex flex-col justify-between"
        [ngClass]="
          !(isLoadedCompany && isLoadedDeals && isLoadedContact)
            ? 'hidden'
            : ''
        "
      >
        <div>
          <div
            [ngClass]="
              contact === null && createCompanyFromReport == false
                ? ' hidden '
                : ''
            "
          >
            <!-- CRM -->
            <div
              class="grid grid-cols-3 gap-2 m-2 mb-3"
              [ngClass]="createCompanyFromReport ? 'hidden' : ''"
            >
              <button
                type="button"
                (click)="changeSidebarTab(0)"
                [ngClass]="
                  sidebarTabs[0].current
                    ? 'bg-violet-500 text-white'
                    : 'bg-violet-500/10 text-violet-500 hover:bg-violet-500/20'
                "
                class="text-xs font-medium text-center py-1.5 rounded-md transition-colors"
              >
                Contact
              </button>

              <button
                type="button"
                (click)="changeSidebarTab(1)"
                [ngClass]="
                  sidebarTabs[1].current
                    ? 'bg-violet-500 text-white'
                    : 'bg-violet-500/10 text-violet-500 hover:bg-violet-500/20'
                "
                class="text-xs font-medium text-center py-1.5 rounded-md transition-colors"
              >
                Company
              </button>
              <button
                type="button"
                (click)="changeSidebarTab(2)"
                [ngClass]="
                  sidebarTabs[2].current
                    ? 'bg-violet-500 text-white'
                    : 'bg-violet-500/10 text-violet-500 hover:bg-violet-500/20'
                "
                class="text-xs font-medium text-center py-1.5 rounded-md transition-colors"
              >
                Deals
              </button>

              <!--        <button type="button" (click)="changeSidebarTab(1)" [ngClass]="sidebarTabs[1].current ? 'bg-primary  text-white' : ' bg-mauve dark:bg-purple-900 text-[#3c4277] dark:text-surface-secondary'" class=" text-center p-1   h-8  rounded-xl">Quotes</button>-->
            </div>
            <!-- / CRM -->

            <!--      Deals-->
            <div
              *ngIf="isConnectedToHubSpot || isConnectedToLivespace"
              class="flex justify-end"
            >
              <button
                *ngIf="sidebarTabs[2].current && isConnectedToHubSpot && activeCrmProvider === 'hubspot'"
                (click)="
                  changeSidebarTab(3); getHsDealPipelines(); getHsDealOwners()
                "
                type="submit"
                class="flex justify-center items-center text-white bg-violet-500 hover:opacity-90 mr-2 rounded-md text-xs px-3 py-1.5 text-center"
              >
                Add deal
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-4 h-4 ml-3"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
              </button>

              <button
                *ngIf="sidebarTabs[2].current && isConnectedToLivespace && activeCrmProvider === 'livespace'"
                (click)="changeSidebarTab(3); loadLivespaceDealFormData()"
                type="button"
                class="flex justify-center items-center text-white bg-blue-600 hover:opacity-90 mr-2 rounded-md text-xs px-3 py-1.5 text-center"
              >
                Add deal
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-4 h-4 ml-3"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M12 4.5v15m7.5-7.5h-15"
                  />
                </svg>
              </button>
            </div>

            <div
              *ngIf="!isConnectedToHubSpot && !isConnectedToLivespace"
              class="bg-primary/10 p-3 rounded-md m-2"
            >
              <p class="text-sm text-[#3c4277]">
                You are disconnected. Your data is not up to date.
              </p>
            </div>

            <ul
              role="list"
              class="m-2 mt-3 h-full"
              *ngIf="sidebarTabs[2].current && deals"
            >
              <li
                *ngFor="let deal of deals"
                class="flex items-center justify-between gap-x-6 px-3 py-3 bg-white dark:border dark:border-[#1c9ed1] dark:bg-[#013549] rounded-lg mb-1"
              >
                <div class="min-w-0 w-full">
                  <div class="flex flex-col items-start">
                    <p
                      *ngIf="formatStage(deal['dealstage'])"
                      [ngClass]="{
                        'text-green-700 bg-green-50 ring-green-600/20':
                          deal['dealstage'] === 'closedwon',
                        'text-red-700 bg-red-50 ring-red-600/20':
                          deal['dealstage'] === 'closedlost',
                        'bg-[#f5f3ff] text-secondary ring-secondary/20':
                          !(deal['dealstage'] === 'closedwon') &&
                          !(deal['dealstage'] === 'closedlost'),
                      }"
                      class="flex rounded-md mt-0.5 px-1.5 py-0.5 mb-2 text-sm font-medium ring-1 ring-inset"
                    >
                      Deal stage: {{ formatStage(deal["dealstage"]) }}
                    </p>

                    <p
                      class="text-sm font-semibold leading-6 text-secondary dark:text-white"
                    >
                      Deal name: {{ deal["dealname"] }}
                    </p>
                  </div>
                  <div
                    class="mt-1 flex flex-col gap-x-2 text-sm leading-5 text-secondary"
                  >
                    <p class="whitespace-nowrap text-sm dark:text-white">
                      Close date:
                      <time datetime="2023-03-17T00:00Z">{{
                        (deal["closedate"] || deal["date_end"]) | date: "MMMM dd yyyy"
                      }}</time>
                    </p>
                    <p
                      *ngIf="deal['pipeline']"
                      class="truncate text-sm dark:text-white"
                    >
                      Pipeline: {{ deal["pipeline"] }}
                    </p>
                    <p
                      *ngIf="deal['amount']"
                      class="truncate text-sm dark:text-white"
                    >
                      Amount: {{ deal["amount"] }} €
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <div class="grid justify-items-center">
              <button
                *ngIf="show_more_deals && sidebarTabs[2].current && deals && activeCrmProvider === 'hubspot'"
                (click)="showMoreDeals()"
                class="text-secondary text-sm"
              >
                Show more
              </button>
            </div>

            <div
              *ngIf="sidebarTabs[2].current && deals?.length === 0 && contact"
              class="bg-primary/10 p-3 rounded-md m-2"
            >
              <p class="text-sm text-[#3c4277] text-center">
                No deals were found for this contact.
              </p>
            </div>
            <!--     / Deals-->

            <!--    Company-->
            <div
              class="max-w-2xl overflow-hidden mx-2"
              *ngIf="sidebarTabs[1].current && company"
            >
              <div>
                <dl class="bg-white dark:bg-secondary-700 rounded-lg overflow-hidden divide-y divide-gray-100 dark:divide-[#3c4377]">

                  <!-- Company Name -->
                  <div *ngIf="company['name']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Company name</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ company["name"] }}</dd>
                  </div>

                  <!-- Domain (clickable link) -->
                  <div *ngIf="company['domain']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Website</dt>
                    <dd class="text-sm text-right break-words max-w-[200px] truncate">
                      <a [href]="company['domain'].startsWith('http') ? company['domain'] : 'https://' + company['domain']"
                        target="_blank" class="text-violet-600 dark:text-violet-400 hover:underline">
                        {{ company["domain"] }}
                      </a>
                    </dd>
                  </div>

                  <!-- Phone -->
                  <div *ngIf="company['phone']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Phone</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">
                      <a [href]="'tel:' + company['phone']" class="text-violet-600 dark:text-violet-400 hover:underline">{{ company["phone"] }}</a>
                    </dd>
                  </div>

                  <!-- Email -->
                  <div *ngIf="company['email']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Email</dt>
                    <dd class="text-sm text-right break-words max-w-[200px] truncate">
                      <a [href]="'mailto:' + company['email']" class="text-violet-600 dark:text-violet-400 hover:underline">{{ company["email"] }}</a>
                    </dd>
                  </div>

                  <!-- Location -->
                  <div *ngIf="company['city'] || company['state'] || company['country']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Location</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">
                      <span *ngIf="company['street']">{{ company["street"] }}, </span>
                      <span *ngIf="company['city']">{{ company["city"] }}</span>
                      <span *ngIf="company['state']">, {{ company["state"] }}</span>
                      <span *ngIf="company['postcode']"> {{ company["postcode"] }}</span>
                      <span *ngIf="company['country']">, {{ company["country"] }}</span>
                    </dd>
                  </div>

                  <!-- Industry -->
                  <div *ngIf="company['industry']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Industry</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ company["industry"] }}</dd>
                  </div>

                  <!-- Employees -->
                  <div *ngIf="company['employees']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Employees</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ company["employees"] }}</dd>
                  </div>

                  <!-- NIP / Tax ID -->
                  <div *ngIf="company['nip']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">NIP / Tax ID</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ company["nip"] }}</dd>
                  </div>

                  <!-- Client Status -->
                  <div *ngIf="company['client_status'] && company['client_status'] !== 'not set'" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Client status</dt>
                    <dd class="text-sm text-right">
                      <span class="inline-flex px-2 py-0.5 text-xs font-medium rounded-full capitalize"
                        [ngClass]="{
                          'bg-green-50 text-green-700': company['client_status'] === 'client',
                          'bg-blue-50 text-blue-700': company['client_status'] === 'potential',
                          'bg-red-50 text-red-700': company['client_status'] === 'lost',
                          'bg-violet-50 text-violet-700': company['client_status'] === 'partner'
                        }">
                        {{ company["client_status"] }}
                      </span>
                    </dd>
                  </div>

                  <!-- Life cycle stage (HubSpot) -->
                  <div *ngIf="company['lifecyclestage']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Life cycle stage</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ company["lifecyclestage"] }}</dd>
                  </div>
                </dl>

                <!-- Social Links Section -->
                <div *ngIf="company['linkedin'] || company['twitter'] || company['facebook']" class="mt-3">
                  <p class="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-2 px-1">Social Profiles</p>
                  <div class="flex flex-wrap gap-2">

                    <!-- LinkedIn -->
                    <a *ngIf="company['linkedin']"
                      [href]="company['linkedin']" target="_blank"
                      class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#0A66C2]/10 text-[#0A66C2] rounded-md text-xs font-medium hover:bg-[#0A66C2]/20 transition-colors">
                      <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                      LinkedIn
                    </a>

                    <!-- Twitter -->
                    <a *ngIf="company['twitter']"
                      [href]="company['twitter']" target="_blank"
                      class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#1DA1F2]/10 text-[#1DA1F2] rounded-md text-xs font-medium hover:bg-[#1DA1F2]/20 transition-colors">
                      <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
                      Twitter
                    </a>

                    <!-- Facebook -->
                    <a *ngIf="company['facebook']"
                      [href]="company['facebook']" target="_blank"
                      class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-[#1877F2]/10 text-[#1877F2] rounded-md text-xs font-medium hover:bg-[#1877F2]/20 transition-colors">
                      <svg class="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
                      Facebook
                    </a>
                  </div>
                </div>
              </div>

              <!-- Update CRM Company button (Livespace) -->
              <button *ngIf="activeCrmProvider === 'livespace' && company?.name"
                type="button"
                (click)="editLivespaceCompany()"
                class="w-full mt-3 flex justify-center items-center gap-2 text-white bg-blue-600 hover:bg-blue-700 rounded-md text-xs px-3 py-2 font-medium transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"/>
                </svg>
                Update CRM company
              </button>
            </div>

            <div
              *ngIf="
                sidebarTabs[1].current &&
                (!company || company?.length === 0 || !company?.name) &&
                contact
              "
              class="bg-primary/10 p-3 rounded-md m-2"
            >
              <p class="text-sm text-[#3c4277] text-center">
                No company was found for this contact.
              </p>

              <button
                *ngIf="activeCrmProvider === 'hubspot'"
                type="button"
                class="flex justify-center items-center mx-auto mt-3 py-1.5 px-3 bg-violet-500 hover:opacity-90 rounded-md"
                (click)="
                  changeSidebarTab(5);
                  getHsCompanyLifeCycleStages();
                  getHsCompanyIndustries()
                "
              >
                <span class="text-xs font-medium text-white"
                  >Create new hubspot company</span
                >
              </button>

              <button
                *ngIf="activeCrmProvider === 'livespace'"
                type="button"
                class="flex justify-center items-center mx-auto mt-3 py-1.5 px-3 bg-blue-600 hover:opacity-90 rounded-md"
                (click)="isEditingCompany = false; prefillLivespaceCompanySocials(); changeSidebarTab(5)"
              >
                <span class="text-xs font-medium text-white"
                  >Create new Livespace company</span
                >
              </button>
            </div>
            <!-- /   Company-->

            <!--Contact-->
            <div
              class="max-w-2xl overflow-hidden mx-2"
              *ngIf="sidebarTabs[0].current && contact"
            >
              <div>
                <dl
                  class="bg-white dark:bg-secondary-700 rounded-lg overflow-hidden divide-y divide-gray-100 dark:divide-[#3c4377]"
                >
                  <div
                    *ngIf="contact['firstname'] || contact['lastname']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Full name
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["firstname"] ?? " " }}
                      {{ contact["lastname"] ?? " " }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['email']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Email address
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["email"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['phone']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Phone
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["phone"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['jobtitle'] || contact['role']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Job Title
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["jobtitle"] || contact["role"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['lifecyclestage']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Life Cycle Stage
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["lifecyclestage"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['address']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Adress
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["address"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['annualrevenue']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Annual revenue
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["annualrevenue"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['city']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      City
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["city"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['company'] || contact['company_name']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Company
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{
                        contact["company"]?.name ||
                          contact["company_name"] ||
                          contact["company"]
                      }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['country']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Country
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["country"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['fax']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Fax
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["fax"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['hs_timezone']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Timezone
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["hs_timezone"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['hs_whatsapp_phone_number']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Whatsapp phone number
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["hs_whatsapp_phone_number"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['industry']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Industry
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["industry"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['mobilephone']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Mobile phone
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["mobilephone"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['numemployees']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Employees
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["numemployees"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['state']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      State
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["state"] }}
                    </dd>
                  </div>

                  <div
                    *ngIf="contact['website']"
                    class="flex items-center justify-between gap-4 px-3 py-2.5"
                  >
                    <dt
                      class="text-sm font-medium text-secondary dark:text-white shrink-0"
                    >
                      Website
                    </dt>
                    <dd
                      class="text-sm text-secondary dark:text-white text-right break-words"
                    >
                      {{ contact["website"] }}
                    </dd>
                  </div>

                  <!-- Livespace: www field -->
                  <div *ngIf="contact['www'] && !contact['website']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Website</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">
                      <a [href]="contact['www']" target="_blank" class="text-violet-600 dark:text-violet-400 hover:underline">{{ contact["www"] }}</a>
                    </dd>
                  </div>

                  <!-- Livespace: Mobile phone -->
                  <div *ngIf="contact['cell']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Mobile</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ contact["cell"] }}</dd>
                  </div>

                  <!-- Livespace: Address -->
                  <div *ngIf="contact['address_street'] || contact['address_city']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Address</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">
                      <span *ngIf="contact['address_street']">{{ contact["address_street"] }}</span>
                      <span *ngIf="contact['address_city']">, {{ contact["address_city"] }}</span>
                      <span *ngIf="contact['address_postcode']"> {{ contact["address_postcode"] }}</span>
                      <span *ngIf="contact['address_country_name']">, {{ contact["address_country_name"] }}</span>
                    </dd>
                  </div>

                  <!-- Livespace: Last active date -->
                  <div *ngIf="contact['last_active_date']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Last active</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ contact["last_active_date"] }}</dd>
                  </div>

                  <!-- Livespace: Contact source -->
                  <div *ngIf="contact['contact_source']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Source</dt>
                    <dd class="text-sm text-secondary dark:text-white text-right break-words">{{ contact["contact_source"] }}</dd>
                  </div>

                  <!-- Livespace: Livespace URL (link to profile) -->
                  <div *ngIf="contact['url']" class="flex items-center justify-between gap-4 px-3 py-2.5">
                    <dt class="text-sm font-medium text-secondary dark:text-white shrink-0">Livespace profile</dt>
                    <dd class="text-sm text-right">
                      <a [href]="contact['url']" target="_blank" class="text-violet-600 dark:text-violet-400 hover:underline text-xs">
                        Open in Livespace
                      </a>
                    </dd>
                  </div>

                  <!-- Livespace: Social Profiles from dataset -->
                  <ng-container
                    *ngIf="
                      activeCrmProvider === 'livespace' &&
                      contactSocialProfiles?.length
                    "
                  >
                    <div
                      *ngFor="let profile of contactSocialProfiles"
                      class="flex items-center justify-between gap-4 px-3 py-2.5"
                    >
                      <dt
                        class="text-sm font-medium text-secondary dark:text-white shrink-0 capitalize"
                      >
                        {{ profile.label }}
                      </dt>
                      <dd
                        class="text-sm text-secondary dark:text-white text-right break-words max-w-[180px] truncate"
                      >
                        <a
                          [href]="profile.value"
                          target="_blank"
                          class="text-violet-600 dark:text-violet-400 hover:underline"
                        >
                          {{ profile.value }}
                        </a>
                      </dd>
                    </div>
                  </ng-container>
                </dl>
              </div>

              <!-- Update CRM Contact button (Livespace) -->
              <button *ngIf="activeCrmProvider === 'livespace' && contact"
                type="button"
                (click)="editLivespaceContact()"
                class="w-full mt-3 flex justify-center items-center gap-2 text-white bg-blue-600 hover:bg-blue-700 rounded-md text-xs px-3 py-2 font-medium transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"/>
                </svg>
                Update CRM contact
              </button>
            </div>

            <!-- Creating New Hubspot Company -->
            <div *ngIf="sidebarTabs[5].current">
              <div class="flex">
                <button
                  [ngClass]="createCompanyFromReport ? 'hidden' : ''"
                  (click)="changeSidebarTab(0)"
                  class="bg-secondary bg-secondary/5 p-2 rounded-full"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="size-4"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M15.75 19.5 8.25 12l7.5-7.5"
                    />
                  </svg>
                </button>
                <h2 class="font-semibold text-secondary dark:text-white">
                  {{
                    activeCrmProvider === "livespace"
                      ? (isEditingCompany
                          ? "Update Livespace Company"
                          : "Creating New Livespace Company")
                      : "Creating New Hubspot Company"
                  }}
                </h2>
              </div>

              <form
                [formGroup]="companyForm"
                (submit)="
                  activeCrmProvider === 'livespace'
                    ? (isEditingCompany ? updateLivespaceCompany() : newLivespaceCompany())
                    : newHubspotCompany()
                "
                *ngIf="sidebarTabs[5].current"
                class="flex flex-col h-full mx-2"
              >
                <div class="sm:my-2">
                  <label
                    for="hs_company_name"
                    class="block text-sm font-medium text-gray-900 dark:text-white"
                    >Name</label
                  >
                  <input
                    id="hs_company_name"
                    name="hs_company_name"
                    formControlName="hs_company_name"
                    type="text"
                    [ngClass]="
                      companyForm.get('hs_company_name').invalid
                        ? ' border-red-500 '
                        : ''
                    "
                    class="input"
                    placeholder="Name"
                  />
                  <div *ngIf="companyForm.get('hs_company_name').invalid">
                    <!-- Other validators can be added similarly -->
                    <div
                      class="ng-invalid text-xs text-red-500 mt-1 ml-1"
                      *ngIf="
                        companyForm.get('hs_company_name').errors?.['maxlength']
                      "
                    >
                      Name is too long.
                    </div>
                  </div>
                </div>

                <div class="sm:my-2">
                  <label
                    for="hs_company_domain"
                    class="block text-sm font-medium text-gray-900 dark:text-white"
                    >Domain</label
                  >
                  <input
                    id="hs_company_domain"
                    name="hs_company_domain"
                    type="text"
                    formControlName="hs_company_domain"
                    class="input"
                    placeholder="Company domain"
                  />
                  <div *ngIf="companyForm.get('hs_company_domain').invalid">
                    <div
                      class="ng-invalid text-xs text-red-500 mt-1 ml-1"
                      *ngIf="
                        companyForm.get('hs_company_domain').errors?.[
                          'required'
                        ]
                      "
                    >
                      Company domain is required.
                    </div>
                    <!-- Other validators can be added similarly -->
                  </div>
                </div>

                <div class="sm:my-2">
                  <label
                    for="hs_company_city"
                    class="block text-sm font-medium text-gray-900 dark:text-white"
                    >City</label
                  >
                  <input
                    id="hs_company_city"
                    name="hs_company_city"
                    type="text"
                    formControlName="hs_company_city"
                    [ngClass]="
                      companyForm.get('hs_company_city').invalid
                        ? ' border-red-500 '
                        : ''
                    "
                    class="input"
                    placeholder="Company City"
                  />
                  <div *ngIf="companyForm.get('hs_company_city').invalid">
                    <!-- Other validators can be added similarly -->
                    <div
                      class="ng-invalid text-xs text-red-500 mt-1 ml-1"
                      *ngIf="
                        companyForm.get('hs_company_city').errors?.['maxlength']
                      "
                    >
                      Company city is too long.
                    </div>
                  </div>
                </div>

                <div class="flex-1 mb-3" *ngIf="activeCrmProvider !== 'livespace'">
                  <label
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Industry *</label
                  >
                  <button
                    id="dropdownButton9"
                    (click)="toggleCompanyIndustriesDropdown()"
                    class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                    type="button"
                  >
                    <span class="truncate dark:text-white">{{
                      industry[0]
                    }}</span>
                    <svg
                      class="w-2.5 h-2.5 ms-3 flex-shrink-0"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>

                  <div
                    [ngClass]="
                      isCompanyIndustriesDropdownOpen !== true ? ' hidden ' : ''
                    "
                    id="dropdown10"
                    class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow border dark:border-[#1c9ed1] dark:bg-[#013549] dark:text-white dark:divide-gray-600"
                  >
                    <ul
                      class="text-sm text-gray-700 dark:text-gray-200"
                      aria-labelledby="dropdownButton"
                    >
                      <li *ngFor="let industry of hs_company_industry">
                        <a
                          (click)="selectCompanyIndustry(industry)"
                          class="flex justify-between items-center truncate cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        >
                          <span class="dark:text-white">{{ industry[0] }}</span>
                          <svg
                            class="ml-2 fill-black dark:fill-white"
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                          >
                            <title>HubSpot icon</title>
                            <path
                              d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="sm:my-2">
                  <label
                    for="hs_company_phone"
                    class="block text-sm font-medium text-gray-900 dark:text-white"
                    >Phone</label
                  >
                  <input
                    id="hs_company_phone"
                    name="hs_company_city"
                    type="text"
                    formControlName="hs_company_phone"
                    [ngClass]="
                      companyForm.get('hs_company_phone').invalid
                        ? ' border-red-500 '
                        : ''
                    "
                    class="input"
                    placeholder="Company phone"
                  />
                  <div *ngIf="companyForm.get('hs_company_phone').invalid">
                    <!-- Other validators can be added similarly -->
                    <div
                      class="ng-invalid text-xs text-red-500 mt-1 ml-1"
                      *ngIf="
                        companyForm.get('hs_company_phone').errors?.[
                          'maxlength'
                        ]
                      "
                    >
                      Company phone is too long.
                    </div>
                  </div>
                </div>

                <div class="sm:my-2">
                  <label
                    for="hs_company_state"
                    class="block text-sm font-medium text-gray-900 dark:text-white"
                    >State</label
                  >
                  <input
                    id="hs_company_state"
                    name="hs_company_state"
                    type="text"
                    formControlName="hs_company_state"
                    [ngClass]="
                      companyForm.get('hs_company_state').invalid
                        ? ' border-red-500 '
                        : ''
                    "
                    class="input"
                    placeholder="Company state"
                  />
                  <div *ngIf="companyForm.get('hs_company_state').invalid">
                    <!-- Other validators can be added similarly -->
                    <div
                      class="ng-invalid text-xs text-red-500 mt-1 ml-1"
                      *ngIf="
                        companyForm.get('hs_company_state').errors?.[
                          'maxlength'
                        ]
                      "
                    >
                      Company state is too long.
                    </div>
                  </div>
                </div>

                <div class="flex-1 mb-3" *ngIf="activeCrmProvider !== 'livespace'">
                  <label
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Life Cycle Stage *</label
                  >
                  <button
                    id="dropdownButton8"
                    (click)="toggleCompanyLifeCycleStagesDropdown()"
                    class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                    type="button"
                  >
                    <span class="truncate dark:text-white">{{
                      life_cycle_stage[0]
                    }}</span>
                    <svg
                      class="w-2.5 h-2.5 ms-3 flex-shrink-0"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>

                  <div
                    [ngClass]="
                      isCompanyLifeCycleStagesDropdownOpen !== true
                        ? ' hidden '
                        : ''
                    "
                    id="dropdown7"
                    class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow border dark:border-[#1c9ed1] dark:bg-[#013549] dark:text-white dark:divide-gray-600"
                  >
                    <ul
                      class="text-sm text-gray-700 dark:text-gray-200"
                      aria-labelledby="dropdownButton"
                    >
                      <li
                        *ngFor="
                          let lifecyclestage of hs_company_life_cycle_stages
                        "
                      >
                        <a
                          (click)="selectCompanyLifeCycleStage(lifecyclestage)"
                          class="flex justify-between items-center truncate cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        >
                          <span class="dark:text-white">{{
                            lifecyclestage[0]
                          }}</span>
                          <svg
                            class="ml-2 fill-black dark:fill-white"
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            role="img"
                          >
                            <title>HubSpot icon</title>
                            <path
                              d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"
                            />
                          </svg>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>


                <!-- Livespace: Social profile inputs -->
                <ng-container *ngIf="activeCrmProvider === 'livespace'">
                  <div class="sm:my-2">
                    <label class="block text-sm font-medium text-gray-900 dark:text-white">LinkedIn URL</label>
                    <input type="url" [(ngModel)]="ls_company_linkedin" [ngModelOptions]="{standalone: true}"
                      class="input" placeholder="https://linkedin.com/company/..."/>
                  </div>

                  <div class="sm:my-2">
                    <label class="block text-sm font-medium text-gray-900 dark:text-white">Twitter URL</label>
                    <input type="url" [(ngModel)]="ls_company_twitter" [ngModelOptions]="{standalone: true}"
                      class="input" placeholder="https://twitter.com/..."/>
                  </div>

                  <div class="sm:my-2">
                    <label class="block text-sm font-medium text-gray-900 dark:text-white">Facebook URL</label>
                    <input type="url" [(ngModel)]="ls_company_facebook" [ngModelOptions]="{standalone: true}"
                      class="input" placeholder="https://facebook.com/..."/>
                  </div>
                </ng-container>

                <div class="pt-1">
                  <button
                    [disabled]="companyForm.invalid || isSubmittingCompany"
                    type="submit"
                    class="w-full flex items-center justify-center gap-2 text-white bg-violet-500 hover:opacity-90 text-xs font-medium px-3 py-1.5 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <svg *ngIf="isSubmittingCompany" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    <span>{{ isSubmittingCompany ? (isEditingCompany ? "Updating..." : "Submitting...") : "Submit" }}</span>
                  </button>
                </div>
              </form>
            </div>
            <!-- / Creating New Hubspot Company -->

            <form
              (ngSubmit)="submitDealForm()"
              *ngIf="sidebarTabs[3].current"
              class="flex flex-col mx-2"
            >
              <div class="flex-1 mb-3">
                <label
                  for="hs_deal_name"
                  class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >Deal Name *</label
                >
                <input
                  [(ngModel)]="hs_deal_name"
                  id="hs_deal_name"
                  name="hs_deal_name"
                  type="text"
                  class="input"
                  placeholder="Deal name"
                  required
                />
              </div>

              <ng-container *ngIf="activeCrmProvider === 'hubspot'">
              <div class="flex-1 mb-3">
                <label
                  for="hs_deal_amount"
                  class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >Pipeline *</label
                >
                <button
                  id="dropdownButton3"
                  (click)="toggleDealPipelinesDropdown()"
                  class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                  type="button"
                >
                  <span class="truncate dark:text-white">{{
                    pipeline[0]
                  }}</span>
                  <svg
                    class="w-4 h-4 flex-shrink-0 text-gray-400 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 9-7 7-7-7"
                    />
                  </svg>
                </button>

                <!-- Dropdown menu -->
                <div
                  [ngClass]="
                    isDealPipelinesDropdownOpen !== true ? ' hidden ' : ''
                  "
                  id="dropdown2"
                  class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white hover:bg-gray-100 divide-y divide-gray-100 rounded-lg shadow dark:divide-gray-600 dark:border-[#1c9ed1] dark:bg-[#013549] dark:text-white"
                >
                  <ul class="text-sm" aria-labelledby="dropdownButton">
                    <li *ngFor="let pipeline of hs_deal_pipelines">
                      <a
                        (click)="selectPipeline(pipeline)"
                        class="flex justify-between items-center truncate cursor-pointer px-4 py-2"
                      >
                        <span class="dark:text-white">{{ pipeline[0] }}</span>
                        <svg
                          class="ml-2 fill-black dark:fill-white"
                          width="16px"
                          height="16px"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          role="img"
                        >
                          <title>HubSpot icon</title>
                          <path
                            d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="flex-1 mb-3">
                <label
                  for="hs_deal_amount"
                  class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >Deal Stage *</label
                >
                <button
                  id="dropdownButton2"
                  (click)="toggleDealStagesDropdown()"
                  [ngClass]="{
                    'opacity-50 pointer-events-none':
                      this.pipeline[0] === 'Select Pipeline',
                    'cursor-not-allowed':
                      this.pipeline[0] === 'Select Pipeline',
                  }"
                  class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                  type="button"
                >
                  <span class="truncate dark:text-white">{{
                    dealstage[0]
                  }}</span>
                  <svg
                    class="w-4 h-4 flex-shrink-0 text-gray-400 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 9-7 7-7-7"
                    />
                  </svg>
                </button>

                <!-- Dropdown menu -->
                <div
                  [ngClass]="
                    isDealStagesDropdownOpen !== true ? ' hidden ' : ''
                  "
                  id="dropdown3"
                  class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow dark:divide-gray-600 dark:border-[#1c9ed1] dark:bg-[#013549] dark:text-white"
                >
                  <ul
                    class="text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownButton"
                  >
                    <li *ngFor="let hs_deal_stage of hs_deal_stages">
                      <a
                        (click)="selectDealStage(hs_deal_stage)"
                        class="flex justify-between items-center truncate px-4 py-2 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        <span class="dark:text-white">{{
                          hs_deal_stage[0]
                        }}</span>
                        <svg
                          class="ml-2 fill-black dark:fill-white"
                          width="16px"
                          height="16px"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          role="img"
                        >
                          <title>HubSpot icon</title>
                          <path
                            d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="flex-1 mb-3">
                <label
                  for="hs_deal_amount"
                  class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >Amount</label
                >
                <input
                  [(ngModel)]="hs_deal_amount"
                  type="text"
                  id="hs_deal_amount"
                  name="hs_deal_amount"
                  class="input"
                  placeholder="100"
                  required
                />
              </div>

              <div class="flex-1 mb-3">
                <label
                  for="hs_deal_amount"
                  class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >Deal Owner</label
                >
                <button
                  id="dropdownButton4"
                  (click)="toggleDealOwnersDropdown()"
                  class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                  type="button"
                >
                  <span class="truncate dark:text-white">{{
                    deal_owner[0]
                  }}</span>
                  <svg
                    class="w-4 h-4 flex-shrink-0 text-gray-400 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m19 9-7 7-7-7"
                    />
                  </svg>
                </button>

                <!-- Dropdown menu -->
                <div
                  [ngClass]="
                    isDealOwnersDropdownOpen !== true ? ' hidden ' : ''
                  "
                  id="dropdown4"
                  class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow dark:border-[#1c9ed1] dark:bg-[#013549]"
                >
                  <ul
                    class="text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownButton"
                  >
                    <li *ngFor="let owner of hs_deal_owners">
                      <a
                        (click)="selectOwner(owner)"
                        class="flex justify-between items-center w-full truncate px-4 py-4 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        {{ owner[0] }}
                        <svg
                          class="ml-2 fill-black dark:fill-white"
                          width="16px"
                          height="16px"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                          role="img"
                        >
                          <title>HubSpot icon</title>
                          <path
                            d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"
                          />
                        </svg>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <label
                  for="hs_deal_close_date"
                  class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                  >Close Date *</label
                >
                <div class="relative">
                  <input
                    type="text"
                    id="hs_deal_close_date"
                    name="hs_deal_close_date"
                    [(ngModel)]="hs_deal_close_date"
                    [matDatepicker]="picker"
                    (click)="picker.open()"
                    readonly
                    placeholder="Choose a date"
                    class="input pr-10 cursor-pointer"
                  />
                  <button
                    type="button"
                    (click)="picker.open()"
                    aria-label="Open calendar"
                    class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-violet-500 focus:outline-none"
                  >
                    <svg
                      class="h-5 w-5"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </button>
                  <mat-datepicker
                    #picker
                    panelClass="hubspot-datepicker"
                  ></mat-datepicker>
                </div>
              </div>
              </ng-container>

              <!-- Livespace-specific deal fields -->
              <ng-container *ngIf="activeCrmProvider === 'livespace'">
                <div class="flex-1 mb-3">
                  <label
                    for="ls_deal_company_name"
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Company Name</label
                  >
                  <input
                    [(ngModel)]="ls_deal_company_name"
                    id="ls_deal_company_name"
                    name="ls_deal_company_name"
                    type="text"
                    class="input"
                    placeholder="Company name"
                  />
                </div>

                <div class="flex-1 mb-3">
                  <label
                    for="ls_deal_contact_name"
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Contact Name</label
                  >
                  <input
                    [(ngModel)]="ls_deal_contact_name"
                    id="ls_deal_contact_name"
                    name="ls_deal_contact_name"
                    type="text"
                    class="input"
                    placeholder="Contact name"
                  />
                </div>

                <div class="flex-1 mb-3">
                  <label
                    for="ls_deal_source"
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Source</label
                  >
                  <button
                    id="lsDealSourceDropdown"
                    (click)="isLsDealSourceDropdownOpen = !isLsDealSourceDropdownOpen"
                    class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                    type="button"
                  >
                    <span class="truncate dark:text-white">{{ ls_deal_source_label || 'Select Source' }}</span>
                    <svg class="w-4 h-4 flex-shrink-0 text-gray-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"/>
                    </svg>
                  </button>
                  <div
                    [ngClass]="isLsDealSourceDropdownOpen !== true ? ' hidden ' : ''"
                    class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow dark:divide-gray-600 dark:border-[#1c9ed1] dark:bg-[#013549] dark:text-white"
                  >
                    <ul class="text-sm" aria-labelledby="lsDealSourceDropdown">
                      <li *ngFor="let source of ls_deal_sources">
                        <a
                          (click)="selectLsDealSource(source)"
                          class="flex items-center truncate cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                        >
                          <span class="dark:text-white">{{ source.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="flex-1 mb-3">
                  <label
                    for="ls_deal_close_date"
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Closing Date</label
                  >
                  <div class="relative">
                    <input
                      type="text"
                      id="ls_deal_close_date"
                      name="ls_deal_close_date"
                      [(ngModel)]="ls_deal_close_date"
                      [matDatepicker]="lsDealPicker"
                      (click)="lsDealPicker.open()"
                      readonly
                      placeholder="Choose a date"
                      class="input pr-10 cursor-pointer"
                    />
                    <button
                      type="button"
                      (click)="lsDealPicker.open()"
                      aria-label="Open calendar"
                      class="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-400 hover:text-blue-500 focus:outline-none"
                    >
                      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z" clip-rule="evenodd"/>
                      </svg>
                    </button>
                    <mat-datepicker #lsDealPicker panelClass="hubspot-datepicker"></mat-datepicker>
                  </div>
                </div>

                <div class="flex-1 mb-3">
                  <label
                    for="ls_deal_owner"
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Owner</label
                  >
                  <button
                    id="lsDealOwnerDropdown"
                    (click)="isLsDealOwnerDropdownOpen = !isLsDealOwnerDropdownOpen"
                    class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                    type="button"
                  >
                    <span class="truncate dark:text-white">{{ ls_deal_owner_label || 'Select Owner' }}</span>
                    <svg class="w-4 h-4 flex-shrink-0 text-gray-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"/>
                    </svg>
                  </button>
                  <div
                    [ngClass]="isLsDealOwnerDropdownOpen !== true ? ' hidden ' : ''"
                    class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow dark:divide-gray-600 dark:border-[#1c9ed1] dark:bg-[#013549] dark:text-white"
                  >
                    <ul class="text-sm" aria-labelledby="lsDealOwnerDropdown">
                      <li *ngFor="let owner of ls_deal_owners">
                        <a
                          (click)="selectLsDealOwner(owner)"
                          class="flex items-center truncate cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                        >
                          <span class="dark:text-white">{{ owner.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="flex-1 mb-3">
                  <label
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Visibility</label
                  >
                  <div class="flex items-center gap-4">
                    <label class="flex items-center gap-1.5 cursor-pointer">
                      <input
                        type="radio"
                        name="ls_deal_visibility"
                        value="public"
                        [(ngModel)]="ls_deal_visibility"
                        class="w-4 h-4 text-blue-600"
                      />
                      <span class="text-sm text-gray-700 dark:text-white">Public</span>
                    </label>
                    <label class="flex items-center gap-1.5 cursor-pointer">
                      <input
                        type="radio"
                        name="ls_deal_visibility"
                        value="private"
                        [(ngModel)]="ls_deal_visibility"
                        class="w-4 h-4 text-blue-600"
                      />
                      <span class="text-sm text-gray-700 dark:text-white">Private</span>
                    </label>
                  </div>
                </div>

                <div class="flex-1 mb-3">
                  <label
                    for="ls_deal_product"
                    class="block mb-1 text-sm font-medium text-gray-900 dark:text-white"
                    >Product</label
                  >
                  <button
                    id="lsDealProductDropdown"
                    (click)="isLsDealProductDropdownOpen = !isLsDealProductDropdownOpen"
                    class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                    type="button"
                  >
                    <span class="truncate dark:text-white">{{ ls_deal_product_label || 'Select Product' }}</span>
                    <svg class="w-4 h-4 flex-shrink-0 text-gray-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"/>
                    </svg>
                  </button>
                  <div
                    [ngClass]="isLsDealProductDropdownOpen !== true ? ' hidden ' : ''"
                    class="z-10 row-start-2 max-h-48 mt-1 overflow-auto bg-white divide-y divide-gray-100 rounded-lg shadow dark:divide-gray-600 dark:border-[#1c9ed1] dark:bg-[#013549] dark:text-white"
                  >
                    <ul class="text-sm" aria-labelledby="lsDealProductDropdown">
                      <li *ngFor="let product of ls_deal_products">
                        <a
                          (click)="selectLsDealProduct(product)"
                          class="flex items-center justify-between truncate cursor-pointer px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                        >
                          <span class="dark:text-white">{{ product.name }}</span>
                          <span *ngIf="product.default_price" class="text-xs text-gray-400 ml-2">{{ product.default_price }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-container>

              <div class="pt-1">
                <button *ngIf="activeCrmProvider === 'hubspot'"
                  [disabled]="this.deal_owner[0] === 'Select Owner'"
                  [@colorChange]="
                    this.deal_owner[0] === 'Select Owner' ||
                    this.pipeline[0] === 'Select Pipeline' ||
                    this.dealstage[0] === 'Select Deal Stage' ||
                    this.hs_deal_close_date === null ||
                    this.hs_deal_name === ''
                      ? 'invalid'
                      : 'valid'
                  "
                  type="submit"
                  class="w-full flex justify-center text-white font-medium rounded-md text-xs px-3 py-1.5 disabled:opacity-50"
                >
                  Submit
                </button>
                <button *ngIf="activeCrmProvider === 'livespace'"
                  [disabled]="!hs_deal_name"
                  type="submit"
                  class="w-full flex justify-center text-white bg-blue-600 hover:bg-blue-700 font-medium rounded-md text-xs px-3 py-1.5 disabled:opacity-50"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div *ngIf="sidebarTabs[4].current">
        <button
          (click)="changeSidebarTab(0)"
          class="bg-secondary bg-secondary/5 p-2 rounded-full"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-4 stroke-2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15.75 19.5 8.25 12l7.5-7.5"
            />
          </svg>
        </button>

        <h2 class="font-semibold text-secondary dark:text-white mt-6">
          <ng-container *ngIf="isEditingContact && activeCrmProvider === 'livespace'">Update Livespace Contact</ng-container>
          <ng-container *ngIf="!isEditingContact && activeCrmProvider === 'livespace'">Creating New Livespace Contact</ng-container>
          <ng-container *ngIf="activeCrmProvider !== 'livespace'">Creating New Hubspot Contact</ng-container>
        </h2>

        <form
          [formGroup]="contactForm"
          (submit)="
            activeCrmProvider === 'livespace'
              ? (isEditingContact ? updateLivespaceContact() : newLivespaceContact())
              : newHubspotContact()
          "
          class="flex flex-col h-full mt-1 mx-2"
        >
          <div class="sm:my-2">
            <label
              for="hs_name"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Name</label
            >
            <input
              id="hs_name"
              name="hs_name"
              formControlName="hs_name"
              type="text"
              [ngClass]="
                contactForm.get('hs_name').invalid ? ' border-red-500 ' : ''
              "
              class="input"
              placeholder="Name"
            />
            <div *ngIf="contactForm.get('hs_name').invalid">
              <div
                class="ng-invalid text-xs text-red-500 mt-1 ml-1"
                *ngIf="contactForm.get('hs_name').errors?.['maxlength']"
              >
                Name is too long.
              </div>
            </div>
          </div>

          <!-- Emails (dynamic multi-input for Livespace) -->
          <div *ngIf="activeCrmProvider === 'livespace'" class="sm:my-2">
            <label
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Email Addresses</label
            >
            <div
              *ngFor="
                let email of ls_email_inputs;
                let i = index;
                trackBy: trackByIndex
              "
              class="flex items-center gap-1 mt-1"
            >
              <input
                type="email"
                [(ngModel)]="ls_email_inputs[i]"
                [ngModelOptions]="{ standalone: true }"
                class="input flex-1"
                placeholder="email@example.com"
              />
              <button
                type="button"
                (click)="removeEmailInput(i)"
                class="shrink-0 p-1 text-red-500 hover:text-red-700 rounded"
                title="Remove"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="w-4 h-4"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5 12h14"
                  />
                </svg>
              </button>
            </div>
            <button
              type="button"
              (click)="addEmailInput()"
              class="mt-1 flex items-center gap-1 text-xs text-violet-600 hover:text-violet-800 dark:text-violet-400"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                class="w-3.5 h-3.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
              Add email
            </button>
          </div>

          <!-- Single email (HubSpot fallback) -->
          <div
            *ngIf="activeCrmProvider !== 'livespace'"
            class="row-start-2 sm:my-2"
          >
            <label
              for="hs_mail"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Mail</label
            >
            <input
              id="hs_mail"
              name="hs_mail"
              type="email"
              [(ngModel)]="hs_mail"
              [ngModelOptions]="{ standalone: true }"
              class="input"
              placeholder="Mail"
              required
            />
          </div>

          <!-- Phone Numbers (dynamic multi-input for Livespace) -->
          <div *ngIf="activeCrmProvider === 'livespace'" class="sm:my-2">
            <label
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Phone Numbers</label
            >
            <div
              *ngFor="
                let phone of ls_phone_inputs;
                let i = index;
                trackBy: trackByIndex
              "
              class="flex items-center gap-1 mt-1"
            >
              <input
                type="text"
                [(ngModel)]="ls_phone_inputs[i]"
                [ngModelOptions]="{ standalone: true }"
                class="input flex-1"
                placeholder="+40 XXXX XX XXXX"
              />
              <button
                type="button"
                (click)="removePhoneInput(i)"
                class="shrink-0 p-1 text-red-500 hover:text-red-700 rounded"
                title="Remove"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="2"
                  stroke="currentColor"
                  class="w-4 h-4"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5 12h14"
                  />
                </svg>
              </button>
            </div>
            <button
              type="button"
              (click)="addPhoneInput()"
              class="mt-1 flex items-center gap-1 text-xs text-violet-600 hover:text-violet-800 dark:text-violet-400"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                class="w-3.5 h-3.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>
              Add phone number
            </button>
          </div>

          <!-- Single phone (HubSpot fallback) -->
          <div
            *ngIf="activeCrmProvider !== 'livespace'"
            class="row-start-3 sm:my-2"
          >
            <label
              for="hs_phone"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Phone Number</label
            >
            <input
              id="hs_phone"
              name="hs_phone"
              type="text"
              [(ngModel)]="hs_phone"
              [ngModelOptions]="{ standalone: true }"
              class="input"
              placeholder="+40 XXXX XX XXXX"
            />
          </div>

          <!-- Social Media (Livespace only) -->
          <div *ngIf="activeCrmProvider === 'livespace'" class="sm:my-2">
            <label
              class="block text-sm font-medium text-gray-900 dark:text-white mb-1"
              >Social Media</label
            >
            <div class="space-y-1.5">
              <div class="flex items-center gap-2">
                <span
                  class="text-xs text-gray-500 dark:text-gray-400 w-16 shrink-0"
                  >LinkedIn</span
                >
                <input
                  type="url"
                  [(ngModel)]="ls_linkedin"
                  [ngModelOptions]="{ standalone: true }"
                  class="input flex-1"
                  placeholder="https://linkedin.com/in/..."
                />
              </div>
              <div class="flex items-center gap-2">
                <span
                  class="text-xs text-gray-500 dark:text-gray-400 w-16 shrink-0"
                  >Twitter/X</span
                >
                <input
                  type="url"
                  [(ngModel)]="ls_twitter"
                  [ngModelOptions]="{ standalone: true }"
                  class="input flex-1"
                  placeholder="https://twitter.com/..."
                />
              </div>
              <div class="flex items-center gap-2">
                <span
                  class="text-xs text-gray-500 dark:text-gray-400 w-16 shrink-0"
                  >Facebook</span
                >
                <input
                  type="url"
                  [(ngModel)]="ls_facebook"
                  [ngModelOptions]="{ standalone: true }"
                  class="input flex-1"
                  placeholder="https://facebook.com/..."
                />
              </div>
            </div>
          </div>

          <div class="row-start-4 sm:my-2">
            <label
              for="hs_brief"
              class="block text-sm font-medium text-gray-900 dark:text-white"
              >Description</label
            >
            <input
              id="hs_brief"
              name="hs_brief"
              type="text"
              formControlName="hs_brief"
              [ngClass]="
                contactForm.get('hs_brief').invalid ? ' border-red-500 ' : ''
              "
              class="input"
              placeholder="Description"
            />
            <div *ngIf="contactForm.get('hs_brief').invalid">
              <div
                class="ng-invalid text-xs text-red-500 mt-1 ml-1"
                *ngIf="contactForm.get('hs_brief').errors?.['maxlength']"
              >
                Brief is too long.
              </div>
            </div>
          </div>

          <div class="relative">
            <!-- Livespace: simple company name field -->
            <div *ngIf="activeCrmProvider === 'livespace'" class="sm:my-2">
              <label
                class="block text-sm font-medium text-gray-900 dark:text-white"
                >Company</label
              >
              <input
                type="text"
                [value]="hs_company_name || ''"
                disabled
                class="input bg-gray-50 dark:bg-[#1e2452] cursor-not-allowed"
                placeholder="From report data"
              />
              <p class="text-xs text-gray-400 mt-1">
                Auto-linked from report data
              </p>
            </div>

            <!-- HubSpot: Dropdown Button -->
            <div *ngIf="activeCrmProvider !== 'livespace'" class="sm:my-2">
              <label
                for="hs_brief"
                class="block text-sm font-medium text-gray-900 dark:text-white"
                >Company</label
              >
              <div class="mt-1">
                <button
                  type="button"
                  id="companiesDropdown"
                  (click)="toggleCompaniesDropdown()"
                  class="input flex items-center justify-between text-left cursor-pointer bg-white dark:bg-secondary"
                  aria-haspopup="listbox"
                  [attr.aria-expanded]="isCompaniesDropdownOpen"
                >
                  <span class="truncate">{{
                    hs_company[0] || "Select Company"
                  }}</span>
                </button>
              </div>
            </div>

            <!-- Dropdown Menu (HubSpot only) -->
            <div
              *ngIf="
                isCompaniesDropdownOpen && activeCrmProvider !== 'livespace'
              "
              id="companiesDropdownMenu"
              class="absolute z-20 w-full overflow-auto bg-white rounded-lg shadow-lg border border-gray-200 max-h-60 focus:outline-none dark:bg-[#013549] dark:text-white dark:border-[#1c9ed1]"
              role="listbox"
            >
              <ul class="py-1">
                <!-- Create Company Option -->
                <li
                  class="border-b border-gray-100 dark:border-gray-600"
                  role="option"
                >
                  <button
                    type="button"
                    (click)="selectCreateCompanyFromReport()"
                    class="flex w-full items-center justify-between px-4 py-2.5 text-sm text-left text-gray-900 hover:bg-gray-100 hover:text-gray-900 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                  >
                    <span class="font-medium">Create Company from Report</span>
                    <svg
                      class="w-5 h-5 text-gray-500 dark:text-gray-300"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 12H5m14 0-4 4m4-4-4-4"
                      />
                    </svg>
                  </button>
                </li>

                <!-- Company List -->
                <li
                  *ngFor="let company of hs_companies; trackBy: trackById"
                  role="option"
                >
                  <button
                    type="button"
                    (click)="selectCompany(company)"
                    class="flex w-full items-center justify-between px-4 py-2.5 text-sm text-left text-gray-900 hover:bg-gray-100 hover:text-gray-900 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                  >
                    <span class="truncate">{{ company[0] }}</span>
                    <svg
                      class="w-4 h-4 text-blue-600 dark:text-blue-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <title>HubSpot icon</title>
                      <path
                        d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z"
                      />
                    </svg>
                  </button>
                </li>

                <!-- No Company Option -->
                <li role="option">
                  <button
                    type="button"
                    (click)="selectCompany()"
                    class="w-full px-4 py-2 text-sm text-left text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-600 dark:hover:text-white"
                  >
                    No company
                  </button>
                </li>
              </ul>
            </div>

            <!-- Submit Button -->
            <div class="mt-4">
              <button
                [disabled]="contactForm.invalid || isSubmittingContact"
                type="submit"
                class="w-full flex items-center justify-center gap-2 py-1.5 px-3 text-xs font-medium text-white bg-violet-500 rounded-md hover:opacity-90 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
              >
                <svg *ngIf="isSubmittingContact" class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>{{ isSubmittingContact ? (isEditingContact ? "Updating..." : "Submitting...") : "Submit" }}</span>
              </button>
            </div>
          </div>
        </form>
      </div>

      <div
        *ngIf="
          (isLoadedCompany || isLoadedDeals || isLoadedContact) &&
          contact === null &&
          sidebarTabs[0].current
        "
      >
        <span
          *ngIf="isConnectedToHubSpot || isConnectedToLivespace"
          class="text-sm leading-none tracking-tight text-secondary/75 dark:text-white"
          >No CRM data could be found for this profile.</span
        >

        <div
          *ngIf="!isConnectedToHubSpot && !isConnectedToLivespace"
          class="flex flex-col gap-3"
        >
          <span class="text-sm text-secondary dark:text-white"
            >Connect a CRM to view and sync data.</span
          >

          <a
            routerLink="/settings/account"
            class="flex items-center gap-2 text-sm font-medium text-primary hover:opacity-90"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 h-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244"
              />
            </svg>
            Connect CRM in Account Settings
          </a>
        </div>

        <button
          *ngIf="
            (isConnectedToHubSpot || isConnectedToLivespace) &&
            activeCrmProvider === 'hubspot'
          "
          type="button"
          class="mt-3 text-white bg-violet-500 hover:opacity-90 text-xs font-medium px-3 py-1.5 rounded-md"
          (click)="changeSidebarTab(4); getHsCompanies()"
        >
          Create new HubSpot contact
        </button>

        <button
          *ngIf="
            (isConnectedToHubSpot || isConnectedToLivespace) &&
            activeCrmProvider === 'livespace'
          "
          type="button"
          class="mt-3 text-white bg-blue-600 hover:opacity-90 text-xs font-medium px-3 py-1.5 rounded-md"
          (click)="changeSidebarTab(4)"
        >
          Create new Livespace contact
        </button>
      </div>

      <div
        class="flex items-center justify-center h-full"
        [ngClass]="
          (isLoadedCompany && isLoadedDeals && isLoadedContact) ||
          (!isConnectedToHubSpot && !isConnectedToLivespace)
            ? 'hidden'
            : ''
        "
      >
        <div>
          <svg
            class="mx-auto animate-spin h-6 w-6 text-violet-500 mb-3"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>
